import { CompanyData } from './../../../types/constants';

import propertyShellBg from './../../../assets/img/propertyshell_bg.png';
import { projects } from './projects';

export const propertyShell: CompanyData = {
  id: 0,
  name: 'PropertyShell Pty Ltd',
  country: 'Australia',
  bg: propertyShellBg,
  position: 'Software Engineer',
  time: 'Nov 2021 - Present',
  description:
    'Property Shell is your all-in-one property development and project marketing technology platform for managing sales on your property projects.',
  projects: projects,
};
